import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatSelectModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule
} from '@angular/material';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { FcTextAreaInputModule } from '@core/components/fc-input/base/fc-text-area-input/fc-text-area-input.module';
import { FcLocationsInputModule } from '@core/components/fc-input/search-many/fc-locations-input/fc-locations-input.module';
import { FcCompanyInputModule } from '@core/components/fc-input/search-one/fc-company-input/fc-company-input.module';
import { FcMaintenanceTypeModule } from '@core/components/fc-input/search-one/fc-maintenance-type-input/fc-maintenance-type-input.module';
import { FcProblemInputModule } from '@core/components/fc-input/search-one/fc-problem-input/fc-problem-input.module';
import { FcSegmentModule } from '@core/components/fc-input/search-one/fc-segment-input/fc-segment-input.module';
import { AssigneesComponentModule } from '@core/components/inputs/assignees/assignees.module';
import { CompaniesComponentModule } from '@core/components/inputs/companies/companies.module';
import { EquipmentsComponentModule } from '@core/components/inputs/equipments/equipments.module';
import { LocationsComponentModule } from '@core/components/inputs/locations/locations.module';
import { MaintenanceTypeModule } from '@core/components/inputs/maintenance-type/maintenance-type.module';
import { ProblemsModule } from '@core/components/inputs/problems/problems.module';
import { RequestersComponentModule } from '@core/components/inputs/requesters/requesters.module';
import { SegmentsModule } from '@core/components/inputs/segments/segments.module';
import { StatusModule } from '@core/components/inputs/status/status.module';
import { LabelSelectorModule } from '@core/components/label-selector/label-selector.module';
import { AddressValidationService } from '@core/services/address-validation/address-validation.service';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { ImportsService } from 'app/main/settings/imports/services/imports.service';
import { ImportsQueriesService } from 'app/main/settings/imports/services/queries/imports.queries.service';
import { PreviousWarrantyDialogModule } from './components/previous-warranty-dialog/previous-warranty-dialog.module';
import { DialogCreateMaintenanceComponent } from './dialog-create-maintenances.component';
import { DialogCreateMaintenancesService } from './dialog-create-maintenances.service';
import { TabGeneralModule } from './tabs/general/tab-general.module';
import { TabLinksModule } from './tabs/links/tab-links.module';

@NgModule({
  entryComponents: [
    DialogCreateMaintenanceComponent
  ],
  declarations: [
    DialogCreateMaintenanceComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatIconModule,
    MatToolbarModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatTooltipModule,
    MatCheckboxModule,
    DisclaimerModule,
    LabelSelectorModule,
    MatDatepickerModule,
    SegmentsModule,
    ProblemsModule,
    RequestersComponentModule,
    StatusModule,
    AssigneesComponentModule,
    LocationsComponentModule,
    CompaniesComponentModule,
    EquipmentsComponentModule,
    MaintenanceTypeModule,
    DateTimePickerModule,
    FcLocationsInputModule,
    FcCompanyInputModule,
    FcProblemInputModule,
    FcMaintenanceTypeModule,
    FcSegmentModule,
    FcTextAreaInputModule,
    TabLinksModule,
    TabGeneralModule,
    PreviousWarrantyDialogModule
  ],
  exports: [
    DialogCreateMaintenanceComponent
  ],
  providers: [
    ImportsService,
    ImportsQueriesService,
    AddressValidationService,
    DialogCreateMaintenancesService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class DialogCreateMaintenanceModule {}
